import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ApiHelperService } from '../../../../shared/services';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Subject } from 'rxjs';
import { CommOperation, Error } from '../../../../shared/models';
import { OperationState } from '../../../../shared/models';
import { ClearNotificationsAction } from '../../../../shared/redux/global/global.actions';
import { DxFileUploaderComponent } from 'devextreme-angular';
import { UploadErrorEvent, UploadStartedEvent } from 'devextreme/ui/file_uploader';

@Component({
  selector: 'sp-admin-export-map-import',
  templateUrl: './admin-export-map-import.component.html',
  styleUrls: ['./admin-export-map-import.component.scss'],
  standalone: false
})
export class AdminExportMapImportComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;
  @ViewChild('dxFileUploader', { static: false }) dxFileUploader: DxFileUploaderComponent;
  @Input() propertyId: string;
  @Output() onClose = new EventEmitter<void>();
  @Output() uploading = new EventEmitter<void>();
  @Output() uploaded = new EventEmitter<CommOperation>();

  formGroup: UntypedFormGroup = new UntypedFormGroup({});

  public fileName: string;
  public showAdvancedOptions = false;
  private ngOnDestroy$ = new Subject();
  private onCloseUpdateComponents = false;
  private errorFound = false;
  dxFileUploadValue: any[] = [];
  hasQueuedFileUpload: boolean = false;
  uploadInProgress: boolean = false;

  constructor(private apiHelper: ApiHelperService,
    private store: Store<AppState>,
    private fb: UntypedFormBuilder) { }

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;
  }

  ngOnInit() {

    this.initForm();

    this.bsModal.onHide.subscribe(() => {
      this.formGroup.controls.fileUpload.reset();
      this.fileName = null;
      this.showAdvancedOptions = false;
      if (this.onCloseUpdateComponents === true) {
        this.onClose.next();
        this.onCloseUpdateComponents = false;
      }
    });
  }

  private initForm() {
    this.formGroup = this.fb.group({
      fileUpload: this.fb.control(''),
    });
  }

  show(): void {
    this.bsModal.show();
  }

  ngOnDestroy() {
    this.ngOnDestroy$.next('ngOnDestroy');
    this.ngOnDestroy$.unsubscribe();
  }

  onDxValueChanged(event: any) {
    const file = event.value[0];

    event.value[0] = event.value[0].name.replace(/[:*?<>#%^&+|/\\]/g, '');
    this.fileName = file.name;

    this.hasQueuedFileUpload = true;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDxUploadStarted(event: UploadStartedEvent) {
    this.uploadInProgress = true;
  }

  onDxUploaded() {
    this.uploadInProgress = false;

    this.formGroup.controls.fileUpload.reset();

    if (this.errorFound === false) {
      this.onCloseUpdateComponents = true;
      const commOperation = new CommOperation();
      commOperation.operationState = OperationState.success;
      this.uploaded.next(commOperation);
    }

    this.bsModal.hide();
  }

  onDxUploadError(event: UploadErrorEvent) {

    this.uploadInProgress = false;

    this.errorFound = true;
    let errors: Error[];
    try {
      const result = JSON.parse(event.error.response);
      errors = result.errors;
    } catch (exp) {
      // eslint-disable-next-line no-console
      console.log(exp);
    } finally {
      const commOperation = new CommOperation();
      commOperation.operationState = OperationState.failed;
      commOperation.errors = errors;
      this.uploaded.next(commOperation);

      this.bsModal.hide();
    }
  }

  dxUpload() {

    const baseUrl = `${this.apiHelper.apiUrl}${this.apiHelper.componentServiceUrl}`;

    const fileUrl = `${baseUrl}/api/admin/property/${this.propertyId}/exportmap`;

    // Sets the Auth Header...
    const token = window.localStorage.getItem('access_token');
    const uploadHeaders = {
      Authorization: `Bearer ${token}`
    };
    this.dxFileUploader.instance.option('uploadHeaders', uploadHeaders);

    this.store.dispatch(new ClearNotificationsAction());
    this.errorFound = false;
    this.uploading.next();

    // Sets the Url...
    this.dxFileUploader.instance.option('uploadUrl', fileUrl);

    // Triggers the file upload to the server...
    this.dxFileUploader.instance.upload();
  }
}
